// extracted by mini-css-extract-plugin
export var copyableField = "_sn-4";
export var customerBadge = "_sn-0";
export var customerInfoTitle = "_sn-2";
export var details = "_sn-1";
export var dropdownContainer = "_sn-5";
export var dropdownImage = "_sn-6";
export var editAssigneeForm = "_sn-a";
export var editButton = "_sn-3";
export var email = "_sn-7";
export var hidden = "_sn-d";
export var input = "_sn-8";
export var saveButton = "_sn-b";
export var shopifyIcon = "_sn-c";
export var suggestionBadge = "_sn-e";
export var suggestionText = "_sn-f";
export var username = "_sn-9";